<template>
  <th colspan="1" rowspan="1" @click="sortValue()">
    <div class="vs-table-text">
      <slot></slot>
      <span v-if="activeSortType" class="sort-th">
        <vs-icon :icon="activeSortType === 'asc' ? 'expand_less' : 'expand_more'" class="th-sort-icon"> </vs-icon>
      </span>
    </div>
  </th>
</template>
<script>
export default {
  name: "UITh",
  props: {
    sortKey: {
      default: null,
      type: String,
    },
  },
  data: () => ({
    sortStatuses: [null, "asc", "desc"],
  }),
  computed: {
    // The table owns the sort state; deriving it here keeps every header in sync
    // and lets the table seed or reset the sort from outside.
    activeSortType() {
      if (!this.sortKey || this.$parent.currentSortKey !== this.sortKey) {
        return null
      }

      return this.$parent.currentSortType
    },
  },
  methods: {
    sortValue() {
      if (!this.sortKey) {
        return
      }

      const current = this.sortStatuses.indexOf(this.activeSortType)
      const next = current === this.sortStatuses.length - 1 ? 0 : current + 1

      this.$parent.sort(this.sortKey, this.sortStatuses[next])
    },
  },
}
</script>
